/**
 * Metadata van het geheugencircuit (Memory cheat sheet), voor het
 * memory-circuit-paneel, de klikbare memory-iconen en de sectie in de
 * circuits-tab van de editor. De poortlijst komt uit de cheat sheet (12
 * poorten). Poort 10 droeg vroeger foutief een memory-icoon; door Steven
 * bevestigd als geen geheugenpoort en op 2026-09-25 uit de memory-gates en
 * de icon-layout verwijderd.
 */
export const HD_MEMORY_CIRCUIT_GATES: readonly number[] = [
  5, 9, 11, 13, 15, 26, 32, 33, 44, 52, 54, 56,
];

/** Is dit een poort van het geheugencircuit (en dus een sectie in het paneel)? */
export function hdIsMemoryCircuitGate(gate: number): boolean {
  return HD_MEMORY_CIRCUIT_GATES.includes(gate);
}

/** Paneel-key van het memory-circuit-paneel (dedup in de FloatingPanelService). */
export const HD_MEMORY_PANEL_KEY = 'memory-circuit';

/** Bodygraph-diagram van het geheugencircuit (gedeeld met de cheat sheet). */
export const HD_MEMORY_CIRCUITRY_ASSET = 'assets/human-design/memory/memory-circuitry.png';

/** `FLOATING_PANEL_DATA` van het memory-circuit-paneel. */
export interface HdMemoryPanelData {
  /** Poort waar het paneel na openen naartoe scrollt, of `null`. */
  readonly focusGate: number | null;
}

/**
 * Pastel-achtergrondkleur per poort-blokje, 1:1 opgemeten uit het Figma-design
 * (node 1410-1596). Enkel voor de cheat-sheet-pagina; het paneel gebruikt de
 * circuit-indicatorkleuren (zie {@link HD_MEMORY_GATE_COLOR}).
 */
export const HD_MEMORY_CHEAT_SHEET_COLOR: Readonly<Record<number, string>> = {
  9: '#EF8D8F', 5: '#F58E94', 26: '#FFB0B5',
  52: '#DCBE95', 54: '#DCBE95', 32: '#E7D6AC', 44: '#F2E0B2',
  11: '#C3E9CC',
  33: '#EAD59F', 56: '#EAD59F',
  13: '#F6FBBC', 15: '#F6FBBC',
};

/**
 * Circuit-indicatorkleur per geheugenpoort (rail van het blokje in het paneel),
 * gelijk aan de circuit-source-of-truth (`HD_BODYGRAPH_CIRCUITS`): collectief-
 * logisch #05A1F9, collectief-abstract #416CAC, tribaal-ondernemend #F01C1C. De
 * cheat-sheet-pagina gebruikt haar eigen pastelkleuren (zie
 * {@link HD_MEMORY_CHEAT_SHEET_COLOR}); het paneel kleurt bewust op circuit,
 * net als bij de voices/angsten.
 */
export const HD_MEMORY_GATE_COLOR: Readonly<Record<number, string>> = {
  9: '#05A1F9', 52: '#05A1F9', 15: '#05A1F9', 5: '#05A1F9',
  11: '#416CAC', 56: '#416CAC', 33: '#416CAC', 13: '#416CAC',
  54: '#F01C1C', 32: '#F01C1C', 44: '#F01C1C', 26: '#F01C1C',
};
